export const state = {
  graphDurationStart: '-1d',
  graphDurationEnd: '0',
  graphInterval: '15m',
  graphUpdateCount: 0,
}

export const mutations = {
  CHANGE_GRAPH_DURATION_START(state, timeStart) {
    state.graphDurationStart = timeStart
  },
  CHANGE_GRAPH_DURATION_END(state, timeEnd) {
    state.graphDurationEnd = timeEnd
  },
  CHANGE_GRAPH_INTERVAL(state, interval) {
    state.graphInterval = interval
  },
  INCREMENT_GRAPH_UPDATE(state) {
    state.graphUpdateCount++
  },
}

export const actions = {
  changeGraphDurationStart({ commit }, timeStart) {
    commit('CHANGE_GRAPH_DURATION_START', timeStart)
  },
  changeGraphDurationEnd({ commit }, timeEnd) {
    commit('CHANGE_GRAPH_DURATION_END', timeEnd)
  },
  changeGraphInterval({ commit }, interval) {
    commit('CHANGE_GRAPH_INTERVAL', interval)
  },
  incrementGraphUpdate({ commit }) {
    commit('INCREMENT_GRAPH_UPDATE')
  },
}
